import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import { FiX } from "react-icons/fi";

export default function MyDialog({ title, children, ...props }) {
  return (
    <Dialog {...props}>
      {(Boolean(title) || Boolean(props.onClose)) && (
        <DialogTitle>
          {title}
          {Boolean(props.onClose) && (
            <Button
              style={{ position: "absolute", right: "10px", top: "10px" }}
              onClick={props.onClose}
            >
              <FiX style={{ fontSize: "25px" }} />
            </Button>
          )}
        </DialogTitle>
      )}
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}
